import { RemoteAmendCellphone } from "../../../../data/usecases/cellphone";
import { AmendCellphone } from "../../../../domain/usecases/amend-cellphone";
import { makeApiUrl, makeAxiosHttpClient } from "../../http";

export const makeRemoteAmendCellphone = (): AmendCellphone =>
  new RemoteAmendCellphone(
    makeApiUrl("/cellphones/amend-cellphone"),
    makeAxiosHttpClient()
  );
